<template>
  <div class="SubtitleMessageDialog">
    <modal
      name="SubtitleMessageDialog"
      transition="nice-modal-fade"
      :pivotY="0.3"
      :classes="[]"
      :clickToClose="false"
      @before-open="beforeOpen"
      @opened="opened();isShow = true"
      @closed="isShow = false"
    >
      <component
        :is="view"
        :msg="msg"
        :textAlign="textAlign"
        :cancelText="cancelText"
        :okText="okText"
        @resultHandler="resultHandler"
      ></component>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UseConfirmationDialog from "./subtitle/dialogs/useConfirmationDialog";
import RemoveSmartVoice from "./subtitle/dialogs/removeSmartVoice";
import Common from "./subtitle/dialogs/common.vue";
import CloseSmartVoiceDialog from "./subtitle/dialogs/closeSmartVoiceDialog";
import TestPlayDisabled from "./subtitle/dialogs/testPlayDisabled";
import NoAudioDialog from "./subtitle/dialogs/noAudioDialog";
import NoDubDialog from "./subtitle/dialogs/noDubDialog";
import QuitSubtitleDialog from "./subtitle/dialogs/quitSubtitleDialog";
import PickUpingDialog from "./subtitle/dialogs/pickUpingDialog";
export default {
  name: "SubtitleMessageDialog",
  data() {
    return {
      view: "",
      msg: "",
      textAlign: "",
      cancelText: "",
      okText: "",
      resultCallback: null,
    };
  },
  props: {},
  components: {
    UseConfirmationDialog,
    RemoveSmartVoice,
    Common,
    CloseSmartVoiceDialog,
    TestPlayDisabled,
    NoAudioDialog,
    NoDubDialog,
    QuitSubtitleDialog,
    PickUpingDialog,
  },
  methods: {
    beforeOpen(ev) {
      this.resultCallback = null;
      this.view = ev.params.view;
      this.msg = ev.params.msg;
      this.cancelText = ev.params.cancelText;
      this.okText = ev.params.okText;
      this.textAlign = ev.params.textAlign;
      if (typeof ev.params.resultCallback == "function") {
        this.resultCallback = ev.params.resultCallback;
      }
      setTimeout(() => {
        this.opened();
      }, 30);
    },
    opened () {
      if (this.view === 'PickUpingDialog') {
        $(this.$el).find('.v--modal-overlay').css({backgroundColor: `rbga(0,0,0,0.8)`}).addClass('PickUpingDialog');
      } else {
        $(this.$el).find('.v--modal-overlay').css({backgroundColor: ''}).removeClass('PickUpingDialog');
      }
    },
    resultHandler(vaule) {
      this.$modal.hide("SubtitleMessageDialog");
      if (this.resultHandler) {
        this.resultCallback(vaule);
      }
    },
  },
  watch: {},
  computed: {},
  created() {},
};
</script>

<style scoped lang='scss'>
.SubtitleMessageDialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 999;

  /deep/ .v--modal-overlay {
    background-color: rgba(0, 0, 0, 0.6);
  }
  /deep/ .v--modal-overlay.PickUpingDialog {
    background-color: rgba(0, 0, 0, 0.8);
  }
}

.rootDom {
  position: relative;
  width: 540px;
  height: 234px;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/SubtitleMessageDialog.vue